export default __webpack_public_path__ + "media/images/brands/dartington-e7c75d4f005fe027b39810929770e885.png";